<template>

  <div class="container">

    <div id="loader">
      <div class="text-center" v-if='loading'>
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>

    </div>


    <div id="content">

      <div class="row mb-2">
        <div class="col-md-12">
          <h4 class="h4" v-if="survey">
            {{ survey.title }}
          </h4>
        </div>
      </div>

      <b-form @submit.prevent="doSubmit()" novalidate>

        <div class="row">

          <!-- Company -->
          <div class="col-md-6 col-sm-12">
            <b-form-group
              class="form-label"
              label="Empresa para la que labora">

              <b-form-select
                v-model="form.database"
                @input="cleanData()"
                :options="companies">
              </b-form-select>
            </b-form-group>
          </div>

          <!-- Gov Id-->
          <div class="col-md-6 col-sm-12">
            <b-form-group
              class="form-label"
              label="Número de cédula">
              <b-input-group
                id="kgroup"
                class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input
                  min="0"
                  type="number"
                  v-model="form.govId"
                  @keyup.enter.native="doSearchEmployee()"
                  @input="cleanData()"
                  placeholder="Número de cédula"
                  required
                >
                </b-form-input>

                <div class="text-center" v-if="loadingEmployee">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Cargando...</span>
                  </div>
                </div>

                <b-button
                  class="is-primary"
                  type="button"
                  :disabled="!isValidId()"
                  role="button"
                  @click="doSearchEmployee()"
                  variant="primary">
                  Buscar
                </b-button>
              </b-input-group>
            </b-form-group>
          </div>
          <!-- Gov Id-->

        </div>

        <div class="row mt-2">

          <!-- Name -->
          <div class="col-md-4 col-sm-12">
            <b-form-group
              class="form-label"
              label="Nombre completo">
              <b-form-input
                v-model="form.name"
                min="0"
                required
                placeholder="- -"
                disabled
              >
              </b-form-input>
            </b-form-group>
          </div>
          <!-- Name -->

          <!-- Code -->
          <div class="col-md-4 col-sm-12">
            <b-form-group
              class="form-label"
              label="Número de gafete">
              <b-form-input
                v-model="form.code"
                placeholder="- -"
                disabled
              >
              </b-form-input>
            </b-form-group>
          </div>
          <!-- Code -->

          <!-- Department -->
          <div class="col-md-4 col-sm-12">
            <b-form-group
              class="form-label"
              label="Bravo">
              <b-form-input
                v-model="form.departmentId"
                placeholder="- -"
                required
                disabled
              >
              </b-form-input>
            </b-form-group>
          </div>
          <!-- Department -->
        </div>

        <hr/>

        <div id="survey" class="mb-5" v-if="loadedEmployee">

          <div id="questions"
            v-for="(question, idx) in survey.questions"
            :key="question.id">

            <div class="row col-md-12" v-if="question.type == 1">
              <b-form-group :label="question.title">
                <b-form-radio
                  v-for="option in question.options"
                  :key="option.id"
                  v-model="form.answers[idx]"
                  :value="option.id">
                  {{ option.content }}
                </b-form-radio>
              </b-form-group>
            </div>

            <div class="row col-md-12" v-if="question.type == 2">
              <b-form-group :label="question.title">
                <b-form-checkbox-group
                  v-for="option in question.options"
                  :key="option.id"
                  v-model="form.answers[idx]">
                  <b-form-checkbox :value="option.id">
                    {{ option.content }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>

          <b-button
            id="btn-submit"
            class="is-primary"
            type="submit"
            :disabled="!isValidForm() || submitting"
            variant="primary">
            Enviar información
          </b-button>

          <div class="text-center" v-if="submitting">
            <div class="spinner-border" role="status">
              <span class="sr-only">Enviando datos...</span>
            </div>
          </div>

        </div>

      </b-form>

      <b-modal
        ref="alert-modal"
        :width="640"
        scroll="keep"
        @ok="resetForm()"
        @cancel="resetForm()">
        <div class="container">
          <div class="content">
            <h3 class="is-5 spaced">
              {{ alert.title }}
            </h3>
            <p class="detail">
              {{ alert.detail }}
            </p>
          </div>
        </div>
      </b-modal>

      <b-modal
        ref="msg-modal"
        :width="640"
        scroll="keep"
        ok-only ok-variant="secondary"
        ok-title="Aceptar">
        <div class="container">
          <div class="content">
            <h3 class="is-5 spaced">
              {{ alert.title }}
            </h3>
            <p class="detail">
              {{ alert.detail }}
            </p>
          </div>
        </div>
      </b-modal>

    </div>

  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'Form',
  data() {
    return {
      selectedCompany: 'knueveint',
      survey: null,
      companies: [
        { value: 'knueveint', text: 'K-9 Internacional' },
        { value: 'cops', text: 'Cops K-9' },
        { value: 'inspectors' , text: 'Klean 9' },
      ],
      loadingEmployee: false,
      loadedEmployee: false,
      loading: true,
      submitting: false,
      selected: [],
      form : {
        surveyId: 1,
        userId: null,
        govId: null,
        departmentId: null,
        database: 'knueveint',
        answers: {},
      },
      alert: {
        title: null,
        detail: null,
      },
    }
  },
  mounted() {
    axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/survey/byId`, {
      params: { id: this.form.surveyId }
    }).then(response => {
      this.survey = response.data
    }).catch(err => {
      this.alert = {
        title: 'Ha ocurrido un error',
        detail: err.response.data
      }
      this.$refs['msg-modal'].hide()
    }).finally(() => {
      this.loading = false;
    })
  },
  methods: {
    resetForm() {
      this.form =  {
        surveyId: 1,
        userId: null,
        govId: null,
        departmentId: null,
        database: 'knueveint',
        answers: {},
      }
      this.$refs['alert-modal'].hide()
    },
    isValidForm() {
      for (let idx=0;idx<this.survey.questions.length;idx++) {
        const value = this.form.answers[idx]
        const question = this.survey.questions[idx]
        if (question.required && !value) {
          return false;
        }
      }
      return true;
    },
    isValidId() {
      return this.form.govId != '';
    },
    capitalizeName(name) {
      let nameParts = name.split(' ');
      var cleanName = '';
      for (var i=0; i < nameParts.length; i++) {
        let nm = nameParts[i].toLowerCase()
        nm = nm.charAt(0).toUpperCase() + nm.slice(1);
        if (i != 0) {
          cleanName += ' '
        }
        cleanName += nm
      }
      return cleanName
    },
    handleEmployee(employee) {
      this.form.name = employee.name
      this.form.code = employee.code
      this.form.departmentId = employee.departmentId
      this.loadedEmployee = true;
    },
    handleError() {
      this.cleanData()
      this.alert = {
        title: 'Empleado no encontrado',
        detail: 'El empleado no ha sido encontrado en nuestra base de datos',
      }
      this.$refs['msg-modal'].show()
    },
    doSearchEmployee() {
      this.loadingEmployee = true;
      axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/invoice/user`, {
        params: {
          govId: this.form.govId,
          database: this.form.database,
        }
      }).then(response => {
        if (response) {
          this.handleEmployee(response.data)
        } else {
          this.handleError()
        }
      }).catch(() => {
        this.handleError()
      }).finally(() => {
        this.loadingEmployee = false
      })
    },
    cleanData() {
      this.form.userId = null
      this.form.name = null
      this.form.code = null
      this.form.departmentId = null
      this.form.answers = [];
      this.loadedEmployee = false;
    },
    doSubmit() {
      const qobjs = []
      const answers = this.form.answers
      for (let idx=0;idx<answers.length;idx++) {
        const question = this.survey.questions[idx]
        const answer = answers[idx]
        if (Array.isArray(answer)) {
          for (const opt of answer) {
            qobjs.push({
              'questionId': question.id,
              'optionId': opt,
            })
          }
        } else {
          qobjs.push({
            'questionId': question.id,
            'optionId': answer,
          })

        }
      }
      const obj = {... this.form}
      obj.answers = qobjs
      this.submitting= true;
      axios.post(`${process.env.VUE_APP_SERVER_ENDPOINT}/survey/register`, obj)
        .then(() => {
          this.resetForm()
          this.alert = {
            title: 'Los datos han sido enviados exitosamente',
            detail: 'Gracias por su aporte',
          }
          this.loadedEmployee = false;
        })
        .catch(err => {
          if (err.response) {
            this.alert = {
              title: 'Atención',
              detail: err.response.data,
            }
            this.loadedEmployee = false;
          }
        })
        .finally(() => {
          this.$refs['alert-modal'].show()
          this.submitting = false
        })
    }
  },

}
</script>

<style scoped>
.container {
  margin-bottom: 20px;
  height: 100%;
}
#btn-submit {
  float: right;
}
</style>
